import { render, staticRenderFns } from "./LogoImg.vue?vue&type=template&id=67ca4116&"
import script from "./LogoImg.vue?vue&type=script&lang=js&"
export * from "./LogoImg.vue?vue&type=script&lang=js&"
import style0 from "./LogoImg.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports